import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { EditClientPage } from "@/features/ventes/components/clients/EditClientPage";

export const Route = createFileRoute("/_app/ventes/clients/$id/edit")({
  loader: requirePermission(PERMISSIONS.VENTES.CLIENTS.EDIT),
  staticData: {
    title: "Modifier client",
    showInBreadcrumb: true,
  },
  component: EditClientPage,
});
